import * as React from 'react'

import { IItem } from '../../../../typings/searchResults'
import MoneyIcon from '../../icons/homePage/money'
import TimeIcon from '../../icons/homePage/time'
import UniqIcon from '../../icons/homePage/uniq'
import { reportBlockClick } from '../../../../common/analytics/homePageAnalytics'
import ItemsSlideBlock from '../itemsSlideBlock/itemsSlideBlock'

import * as styles from './valuePropositionBlock.module.css'

interface ITiles {
  title: string
  description: string
  icon: string
}

interface IProps {
  title: string
  data: IItem[]
  tiles: ITiles[]
}

const icons = new Map([
  ['money', MoneyIcon],
  ['time', TimeIcon],
  ['uniq', UniqIcon]
])

const reportValuePropositionBlockClick = (
  eventLabel: string,
  eventValue?: number
) => {
  reportBlockClick('Value Proposition', {
    dimension19: 'body',
    eventAction: 'click;link',
    eventLabel,
    eventValue
  })
}

const ValuePropositionBlock = ({ data, title, tiles }: IProps) => {
  return (
    <ItemsSlideBlock
      title={title}
      data={data}
      headerAlign="right"
      hideSlideOnMobile
      onItemClick={(item, index) =>
        reportValuePropositionBlockClick(`${item.id}`, index)
      }
    >
      <div className={styles.tilesArea}>
        {tiles.map((tile, index) => {
          const Icon = icons.get(tile.icon)
          return (
            <div className={styles.tile} key={index}>
              {Icon && (
                <div className={styles.tileIcon}>
                  <Icon width="48" height="48" />
                </div>
              )}
              <div className={styles.tileContent}>
                <h3 className={styles.tileTitle}>{tile.title}</h3>
                <div className={styles.tileDescription}>{tile.description}</div>
              </div>
            </div>
          )
        })}
      </div>
    </ItemsSlideBlock>
  )
}

export default ValuePropositionBlock
